import { Outlet } from 'react-router';
import { BrandAssetType, BrandLogo, useAssetUrl } from '@packlink/tenant-theme-provider';
import { useTranslation } from '@packlink/translation-provider';

import { useFeatureFlags } from '@common/hooks/useFeatureFlags';
import { OnboardingProgressBar } from '../components/OnboardingProgressBar/OnboardingProgressBar';
import { getHeaderStyles, getOnboardingLayoutStyles, getOnboardingLogoStyles } from './OnboardingLayoutStyles';

export function OnboardingLayout(): JSX.Element {
    const { t } = useTranslation();
    const getLogo = useAssetUrl(BrandAssetType.LOGO);
    const { newOnboarding } = useFeatureFlags();

    return (
        <>
            <header css={getHeaderStyles}>
                <img
                    alt="logo"
                    css={getOnboardingLogoStyles}
                    src={getLogo(BrandLogo.LOGO)}
                    title={t('app.helmet.title')}
                />
            </header>

            {newOnboarding && <OnboardingProgressBar />}

            <main css={getOnboardingLayoutStyles}>
                <Outlet />
            </main>
        </>
    );
}
